import { render, staticRenderFns } from "./PriceListDelete.vue?vue&type=template&id=6936dd84&"
import script from "./PriceListDelete.vue?vue&type=script&lang=js&"
export * from "./PriceListDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports